<div class="container-fluid">
  <div class="row pt-4 pl-4" style="font-size: 22px !important;
  font-weight: 400;
  color: #424242;">
    <h5><i class="fa fa-circle" style="color:#800000"></i> &nbsp;Client Billing</h5>
  </div>
<div id="mainContent" class="container">
  <div class="modal-body">
  <div class="row">
    <div class="col-sm-5">
      <div class="row">
        <label class="col-sm-3">Branch </label>
        <div class="col-sm-7">
          <select
            class="form-control form-control-xs"
            id="branch"
            name="branch"
            [(ngModel)]="branch"
            (change)="onSelectBranch()"
          >
            <option value="">Select Branch</option>
            <option *ngFor="let branch of branchDataList" [value]="branch.id">
              {{ branch.name }}
            </option>
          </select>
        </div>
      </div>
    </div>
    <div class="col-sm-5">
      <div class="row">
        <label class="col-sm-3">Client </label>
        <div class="col-sm-7">
          <select
            class="form-control form-control-xs"
            id="client"
            name="client"
            [(ngModel)]="client"
            (change)="onSelectClient()"
          >
            <option value="">Select Client</option>
            <option *ngFor="let client of clientList" [value]="client.id">
              {{ client.name }}
            </option>
          </select>
        </div>
      </div>
    </div>
  </div>

  <div class="row mt-4">
    <div class="col-sm-5">
      <div class="row">
        <label class="col-sm-3">Assignment </label>
        <div class="col-sm-7">
          <select
            class="form-control form-control-xs"
            id="assignment"
            name="assignment"
            [(ngModel)]="assignment"
          >
            <option value="">Select Assignment</option>
            <option
              *ngFor="let assignment of assignmentList"
              [value]="assignment.id"
            >
              {{ assignment.name }}
            </option>
          </select>
        </div>
      </div>
    </div>
    <div class="col-sm-5">
      <div class="row">
    <div class="col-sm-4">
      <button
        class="btn btn-sm btn-block btn-outline-theme"
        (click)="onClickBranchByClient()"
      >
        View Details
      </button>
    </div>
  
    <div class="col-sm-4" *ngIf="showDetailTable">
      <button
        class="btn btn-sm btn-block btn-outline-theme"
        (click)="onGenerateBill()"
      >
        Generate Bill
      </button>
    </div>
  </div>
</div>
</div>

<div class="row mt-4">
  <div class="col-sm-2" *ngIf="showDetailTable">
    <button (click)="exportToExcelClick()" class="btn btn-sm btn-block btn-outline-theme">
      <i class="fa fa-file-excel-o mr-2"></i>Export to Excel
    </button>
  </div>

  <div class="col-sm-2" *ngIf="showDetailTable">
    <button (click)="exportToPDFClick()" class="btn btn-sm btn-block btn-outline-theme">
      <i class="fa fa-file-pdf-o mr-2"></i>Export as PDF
    </button>
  </div>
</div>
</div>
</div>

<div class="container" id="mainContent">
  <div
    class="pt-3"
    *ngIf="showDetailTable"
  >

  <div class="row justify-content-center text-center">
    <span class="bg-theme-title">P G BHAGWAT LLP, Chartered Accountants</span>
  </div>
  <div class="row justify-content-center text-center ">
    <span>Suite 102, "Orchard", Dr Pai Marg, Baner, Pune - 411045 </span>
  </div>
      <div class="row justify-content-center text-center mt-2">
        <span class="bg-theme-title">Diary Conveyance Details</span>
    </div>
    <div class="row pt-1">
    <div class="col-md-12">
      <table class="table table-bordered table-striped table-sm">
        <thead>
          <tr>
            <th>Month/Year</th>
            <th>Two Wheeler Amount</th>
            <th>Four Wheeler Amount</th>
            <th>Bus/Auto/Other Amount</th>
            <th>Pending to be billed Amount</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let item of finalGroupByMonth">
            <td>{{ getMonthFormat(item.month) }} / {{ item.year }}</td>
            <td>{{ item.amount.twoWheeler }}</td>
            <td>{{ item.amount.fourWheeler | number: "1.2-2" }}</td>
            <td>{{ item.amount.busAuto }}</td>
            <td>
              {{
                item.amount.twoWheeler +
                  item.amount.fourWheeler +
                  item.amount.busAuto
              }}
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    </div>
  </div>
  <div
    class="pt-4"
    *ngIf="showDetailTable"
  >
    <div class="row col-md-12">
      <table class="table table-bordered table-sm table-striped">
        <thead>
          <tr>
            <th>Month/Year</th>
            <th>Employee Name</th>
            <th>Date</th>
            <th>Mode</th>
            <th>Pending to be billed Amount</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let data of diaryClientBillingList">
            <td>{{ getMonthFormat(data.month) }} / {{ data.year }}</td>
            <td>
              {{ data.user.firstName }} {{ data.user.middleName }}
              {{ data.user.lastName }}
            </td>
            <td>{{ data.entryDate | date: "dd-MMM-yyyy" }}</td>
            <td>{{ data.mode }}</td>
            <td>{{ data.amount | number: "1.2-2" }}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
  </div>

  <div class="container" id="mainContent">
  <div
    class="pt-2"
    *ngIf="showDetailTable"
  >
    <div class="row">
      <div class="col-sm-4"></div>
      <div class="col-sm-7">
        <span class="bg-theme-title">Travel Conveyance Details</span>
      </div>
    </div>
    <div class="row mt-2">
      <div class="col-md-12">
      <table class="table table-bordered table-sm table-striped">
        <thead>
          <tr>
            <!-- <th>Month/Year</th> -->
            <th>Employee Name</th>
            <th>Date</th>
            <th>Pending to be billed Amount</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let data of travelSheetClientBillingList">
            <!-- <td>{{ getMonthFormat(data.month) }} / {{ data.year }}</td> -->
            <td>
              {{ data.user.firstName }} {{ data.user.middleName }}
              {{ data.user.lastName }}
            </td>
            <td>{{ data.entryDate | date: "dd-MMM-yyyy" }}</td>
            <td>{{ data.amount | number: "1.2-2" }}</td>
          </tr>
        </tbody>
      </table>
    </div>
    </div>
  </div>
</div>
</div>
